import { render, staticRenderFns } from "./Absences.vue?vue&type=template&id=723eece7&"
import script from "./Absences.vue?vue&type=script&lang=ts&"
export * from "./Absences.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports